export default __webpack_public_path__ + "static/completed-71759c6122b5197c33e5bef1cfd09a48.png";